import React, { useState, useMemo } from "react";
import { Layout, Typography, Card, Row, Col, Tabs, Button, Pagination, Input, Select } from "antd";
import { FaShoppingCart, FaDollarSign, FaStar } from "react-icons/fa";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const products = [
  { 
    id: 1, 
    name: "AI Chatbot API", 
    category: "APIs", 
    seller: "TechAI Labs", 
    price: 99, 
    description: "A powerful AI chatbot API designed for seamless integration into websites, apps, and customer service platforms. Supports natural language processing (NLP), multi-language capabilities, and real-time responses to enhance user engagement and automate support tasks.", 
    rating: 4.5,
    imageUrl: "https://c.mql5.com/31/1290/gold-scalping-ai-mt5-logo-200x200-3906.png"
  },
  { 
    id: 2, 
    name: "Fraud Detection Model", 
    category: "AI Models", 
    seller: "SecureAI", 
    price: 199, 
    description: "An advanced AI model for detecting fraudulent transactions in real-time. Utilizes machine learning algorithms to analyze patterns, flag anomalies, and reduce false positives, making it ideal for financial institutions and e-commerce platforms seeking robust security.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=Fraud+Detection+Model"
  },
  { 
    id: 3, 
    name: "Medical Diagnosis AI", 
    category: "AI Software", 
    seller: "MediTech", 
    price: 299, 
    description: "AI-powered software for medical diagnosis, leveraging deep learning to assist doctors in identifying diseases from medical imaging and patient data. Offers high accuracy, integration with EHR systems, and support for telemedicine applications.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Medical+Diagnosis+AI"
  },
  { 
    id: 4, 
    name: "Speech Recognition Dataset", 
    category: "Datasets", 
    seller: "DataX", 
    price: 49, 
    description: "A high-quality dataset for training speech recognition models, featuring over 10,000 hours of diverse audio samples across multiple languages and accents. Perfect for building voice assistants, transcription tools, or accessibility solutions.", 
    rating: 4.3,
    imageUrl: "https://via.placeholder.com/150?text=Speech+Recognition+Dataset"
  },
  { 
    id: 5, 
    name: "Automated Resume Screener", 
    category: "Automation Tools", 
    seller: "HRTech", 
    price: 149, 
    description: "An AI-driven tool for screening job applications, capable of parsing resumes, ranking candidates based on skills and experience, and reducing hiring time. Includes customizable filters and integration with HR platforms for streamlined recruitment.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Automated+Resume+Screener"
  },
  { 
    id: 6, 
    name: "Forex Prediction AI", 
    category: "Forex Trading Software", 
    seller: "TradeTech", 
    price: 299, 
    description: "AI software designed to predict forex market trends using historical data, technical indicators, and real-time market analysis. Offers actionable insights for traders, with support for multiple currency pairs and automated trading strategies.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Forex+Prediction+AI"
  },
  { 
    id: 7, 
    name: "Crypto Trading Bot", 
    category: "Trading Bots", 
    seller: "CryptoBotX", 
    price: 399, 
    description: "An AI-powered bot for automated cryptocurrency trading, featuring advanced algorithms for market analysis, risk management, and profit optimization. Supports major exchanges like Binance and Coinbase with 24/7 operation.", 
    rating: 4.9,
    imageUrl: "https://c.mql5.com/31/1290/gold-scalping-ai-mt5-logo-200x200-3906.png"
  },
  { 
    id: 8, 
    name: "Goldenity AI", 
    category: "AI Trading Software", 
    seller: "Goldenity", 
    price: 399, 
    description: "An AI-driven trading system tailored for gold markets, utilizing predictive analytics and real-time price tracking to maximize returns. Includes customizable settings for scalping, swing trading, and long-term investment strategies.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Goldenity+AI"
  },
  { 
    id: 9, 
    name: "Gold Scalping AI", 
    category: "AI Trading Software", 
    seller: "GoldScalpingAI", 
    price: 399, 
    description: "An AI-based scalping expert advisor (EA) for MetaTrader 5, optimized for gold trading. Employs high-frequency trading techniques and risk management tools to capitalize on small price movements in volatile markets.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Gold+Scalping+AI"
  },
  { 
    id: 10, 
    name: "Beatrix Inventor EA", 
    category: "AI Trading Software", 
    seller: "BeatrixInventor", 
    price: 299, 
    description: "A trend-following expert advisor (EA) using Bollinger Bands and Moving Averages to identify market trends. Designed for forex trading, it offers adaptive strategies and low drawdown for consistent performance across various pairs.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Beatrix+Inventor+EA"
  },
  { 
    id: 11, 
    name: "Eternal Engine EA", 
    category: "AI Trading Software", 
    seller: "EternalEngine", 
    price: 699, 
    description: "An advanced expert advisor (EA) combining grid and martingale strategies for high-profit potential. Built for experienced traders, it includes risk controls and is optimized for forex pairs like EURUSD and USDJPY.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Eternal+Engine+EA"
  },
  { 
    id: 12, 
    name: "Mean Machine EA", 
    category: "AI Trading Software", 
    seller: "MeanMachine", 
    price: 299, 
    description: "An AI-driven trading EA with dynamic position management, designed to adapt to market conditions. Offers features like stop-loss optimization and trend detection, making it suitable for forex and commodity trading.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=Mean+Machine+EA"
  },
  { 
    id: 13, 
    name: "Quantum Emperor EA", 
    category: "AI Trading Software", 
    seller: "QuantumEmperor", 
    price: 1999, 
    description: "A premium expert advisor (EA) for GBPUSD trading, featuring a unique strategy blending quantum computing principles with AI. Offers unparalleled precision, advanced risk management, and high profitability for serious traders.", 
    rating: 4.9,
    imageUrl: "https://via.placeholder.com/150?text=Quantum+Emperor+EA"
  },
  { 
    id: 14, 
    name: "Quantum Bitcoin EA", 
    category: "AI Trading Software", 
    seller: "QuantumBitcoin", 
    price: 1999, 
    description: "An AI-powered expert advisor (EA) for Bitcoin trading, leveraging quantum-inspired algorithms to predict market shifts. Includes volatility analysis, automated trade execution, and integration with major crypto platforms.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Quantum+Bitcoin+EA"
  },
  { 
    id: 15, 
    name: "Quantum Queen EA", 
    category: "AI Trading Software", 
    seller: "QuantumQueen", 
    price: 999, 
    description: "An AI-driven expert advisor (EA) optimized for gold trading, using quantum techniques for trend prediction and risk assessment. Ideal for traders seeking high returns with robust performance in precious metal markets.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Quantum+Queen+EA"
  },
  { 
    id: 16, 
    name: "Infinity EA", 
    category: "AI Trading Software", 
    seller: "InfinityEA", 
    price: 599, 
    description: "A scalping expert advisor (EA) with machine learning and AI integration, designed for high-frequency forex trading. Features adaptive algorithms, low latency execution, and support for multiple currency pairs.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Infinity+EA"
  },
  { 
    id: 17, 
    name: "AlphaWave Ai", 
    category: "AI Trading Software", 
    seller: "AlphaWaveAi", 
    price: 750, 
    description: "An AI platform for executing complex trading strategies across forex, stocks, and crypto. Combines wave analysis, predictive modeling, and real-time data feeds for professional traders seeking an edge.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=AlphaWave+Ai"
  },
  { 
    id: 18, 
    name: "Paradox Flux Trader", 
    category: "AI Trading Software", 
    seller: "ParadoxFlux", 
    price: 499, 
    description: "A next-generation trading system for gold markets, using AI to analyze flux patterns and market dynamics. Offers automated trading, custom indicators, and a user-friendly interface for both novice and expert traders.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=Paradox+Flux+Trader"
  },
  { 
    id: 19, 
    name: "Gold One MT5", 
    category: "AI Trading Software", 
    seller: "GoldOne", 
    price: 299, 
    description: "An advanced trading robot for gold markets on MetaTrader 5, featuring AI-driven decision-making and real-time market adaptation. Includes risk management tools and supports multiple timeframes for versatile trading.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Gold+One+MT5"
  },
  { 
    id: 20, 
    name: "Sentiment Analysis API", 
    category: "APIs", 
    seller: "SentimentTech", 
    price: 129, 
    description: "An API for real-time text sentiment analysis, powered by NLP to detect positive, negative, or neutral tones. Ideal for social media monitoring, customer feedback analysis, and market research applications.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Sentiment+Analysis+API"
  },
  { 
    id: 21, 
    name: "Predictive Maintenance Model", 
    category: "AI Models", 
    seller: "IndustriAI", 
    price: 249, 
    description: "An AI model for predicting equipment failures in industrial settings, using sensor data and machine learning to minimize downtime. Supports integration with IoT devices and offers actionable maintenance insights.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Predictive+Maintenance+Model"
  },
  { 
    id: 22, 
    name: "Traffic Prediction AI", 
    category: "AI Software", 
    seller: "UrbanTech", 
    price: 349, 
    description: "AI software for urban traffic forecasting, analyzing real-time data from cameras, GPS, and weather sources. Helps city planners optimize traffic flow, reduce congestion, and improve transportation efficiency.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Traffic+Prediction+AI"
  },
  { 
    id: 23, 
    name: "Image Classification Dataset", 
    category: "Datasets", 
    seller: "VisionData", 
    price: 79, 
    description: "A comprehensive dataset for training image classification models, containing millions of labeled images across diverse categories. Perfect for computer vision projects like object detection and facial recognition.", 
    rating: 4.3,
    imageUrl: "https://via.placeholder.com/150?text=Image+Classification+Dataset"
  },
  { 
    id: 24, 
    name: "Customer Support Automation", 
    category: "Automation Tools", 
    seller: "SupportAI", 
    price: 179, 
    description: "An AI tool for automating customer support queries, featuring chatbot integration, ticket categorization, and response generation. Reduces workload for support teams and improves response times for businesses.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Customer+Support+Automation"
  },
  { 
    id: 25, 
    name: "Stock Market Predictor", 
    category: "Forex Trading Software", 
    seller: "MarketPulse", 
    price: 499, 
    description: "AI software for stock market trend analysis, using historical data, news sentiment, and technical indicators to forecast price movements. Ideal for day traders and long-term investors seeking data-driven insights.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=Stock+Market+Predictor"
  },
  { 
    id: 26, 
    name: "Options Trading Bot", 
    category: "Trading Bots", 
    seller: "OptionTrader", 
    price: 599, 
    description: "An AI bot for automated options trading, designed to execute strategies like straddles and spreads based on market conditions. Integrates with brokers and provides real-time analytics for optimal trades.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Options+Trading+Bot"
  },
  { 
    id: 27, 
    name: "Emotion Detection API", 
    category: "APIs", 
    seller: "EmotionAI", 
    price: 159, 
    description: "An API for detecting emotions from text or voice inputs, using AI to analyze tone, pitch, and sentiment. Great for enhancing user experiences in call centers, gaming, or mental health applications.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Emotion+Detection+API"
  },
  { 
    id: 28, 
    name: "Anomaly Detection Model", 
    category: "AI Models", 
    seller: "AnomalyTech", 
    price: 229, 
    description: "An AI model for identifying anomalies in data streams, perfect for cybersecurity, IoT monitoring, or financial auditing. Features unsupervised learning and real-time alerts for unusual patterns.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Anomaly+Detection+Model"
  },
  { 
    id: 29, 
    name: "Inventory Management AI", 
    category: "AI Software", 
    seller: "InventorySmart", 
    price: 399, 
    description: "AI software for optimizing inventory management, predicting demand, and reducing overstock. Integrates with ERP systems and provides real-time insights for retailers and supply chain managers.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Inventory+Management+AI"
  },
  { 
    id: 30, 
    name: "Text Summarization Dataset", 
    category: "Datasets", 
    seller: "TextCorp", 
    price: 89, 
    description: "A dataset for training text summarization models, featuring thousands of articles paired with concise summaries. Ideal for developing NLP tools for news aggregation, research, or content creation.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Text+Summarization+Dataset"
  },
  { 
    id: 31, 
    name: "Email Automation Tool", 
    category: "Automation Tools", 
    seller: "EmailAI", 
    price: 139, 
    description: "An AI tool for automating email responses, featuring smart categorization, draft generation, and sentiment analysis. Boosts productivity for customer service teams and marketing campaigns.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Email+Automation+Tool"
  },
  { 
    id: 32, 
    name: "Commodities Trading AI", 
    category: "Forex Trading Software", 
    seller: "CommoTech", 
    price: 449, 
    description: "AI software for predicting commodities market trends, analyzing supply-demand dynamics, and executing trades. Supports oil, gold, and agricultural markets with real-time data integration.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Commodities+Trading+AI"
  },
  { 
    id: 33, 
    name: "Futures Trading Bot", 
    category: "Trading Bots", 
    seller: "FutureBot", 
    price: 699, 
    description: "An AI bot for futures market trading, automating strategies based on technical analysis and market forecasts. Offers low-latency execution and risk management for indices, commodities, and more.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=Futures+Trading+Bot"
  },
  { 
    id: 34, 
    name: "Face Recognition API", 
    category: "APIs", 
    seller: "FaceIDTech", 
    price: 199, 
    description: "An API for real-time face recognition, powered by deep learning to identify individuals from images or video feeds. Suitable for security systems, authentication, and personalized marketing solutions.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Face+Recognition+API"
  },
  { 
    id: 35, 
    name: "Time Series Forecasting Model", 
    category: "AI Models", 
    seller: "TimeAI", 
    price: 259, 
    description: "An AI model for time series data forecasting, excelling in predicting trends in finance, weather, or sales data. Features LSTM networks and supports multi-variable inputs for accurate predictions.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Time+Series+Forecasting+Model"
  },
  { 
    id: 36, 
    name: "Supply Chain Optimization AI", 
    category: "AI Software", 
    seller: "ChainTech", 
    price: 499, 
    description: "AI software for optimizing supply chain operations, predicting delays, and improving logistics efficiency. Integrates with ERP systems and uses real-time data for dynamic decision-making.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Supply+Chain+Optimization+AI"
  },
  { 
    id: 37, 
    name: "Video Annotation Dataset", 
    category: "Datasets", 
    seller: "VideoData", 
    price: 99, 
    description: "A dataset for video annotation and analysis, containing thousands of annotated video clips for training AI models. Perfect for autonomous driving, surveillance, or video content analysis projects.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Video+Annotation+Dataset"
  },
  { 
    id: 38, 
    name: "Chatbot Automation Tool", 
    category: "Automation Tools", 
    seller: "ChatAI", 
    price: 169, 
    description: "An AI tool for automating chatbot interactions, featuring NLP for natural conversations and integration with messaging platforms. Reduces manual effort in customer support and sales funnels.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Chatbot+Automation+Tool"
  },
  { 
    id: 39, 
    name: "Index Fund Predictor", 
    category: "Forex Trading Software", 
    seller: "IndexAI", 
    price: 399, 
    description: "AI software for predicting index fund trends, analyzing market indices like S&P 500 or FTSE 100. Provides real-time insights and automated trading signals for portfolio optimization.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Index+Fund+Predictor"
  },
  { 
    id: 40, 
    name: "Scalping Trading Bot", 
    category: "Trading Bots", 
    seller: "ScalpBot", 
    price: 799, 
    description: "An AI bot for high-frequency scalping trades, targeting small price movements in forex and crypto markets. Features ultra-fast execution, risk controls, and compatibility with MT4/MT5 platforms.", 
    rating: 4.9,
    imageUrl: "https://via.placeholder.com/150?text=Scalping+Trading+Bot"
  },
  { 
    id: 41, 
    name: "Voice Synthesis API", 
    category: "APIs", 
    seller: "VoiceTech", 
    price: 149, 
    description: "An API for generating synthetic voices, offering lifelike speech synthesis for audiobooks, virtual assistants, or accessibility tools. Supports multiple languages and customizable voice tones.", 
    rating: 4.4,
    imageUrl: "https://via.placeholder.com/150?text=Voice+Synthesis+API"
  },
  { 
    id: 42, 
    name: "Customer Segmentation Model", 
    category: "AI Models", 
    seller: "SegmentAI", 
    price: 189, 
    description: "An AI model for customer segmentation analysis, clustering clients based on behavior, demographics, and purchase history. Ideal for marketing teams aiming to personalize campaigns effectively.", 
    rating: 4.6,
    imageUrl: "https://via.placeholder.com/150?text=Customer+Segmentation+Model"
  },
  { 
    id: 43, 
    name: "Retail Analytics AI", 
    category: "AI Software", 
    seller: "RetailTech", 
    price: 349, 
    description: "AI software for retail sales analytics, predicting customer demand, and optimizing pricing strategies. Integrates with POS systems and provides actionable insights for store performance.", 
    rating: 4.5,
    imageUrl: "https://via.placeholder.com/150?text=Retail+Analytics+AI"
  },
  { 
    id: 44, 
    name: "Sentiment Analysis Dataset", 
    category: "Datasets", 
    seller: "SentimentData", 
    price: 69, 
    description: "A dataset for training sentiment analysis models, featuring labeled text from reviews, tweets, and forums. Great for building NLP tools to gauge public opinion or customer satisfaction.", 
    rating: 4.3,
    imageUrl: "https://via.placeholder.com/150?text=Sentiment+Analysis+Dataset"
  },
  { 
    id: 45, 
    name: "Marketing Automation Tool", 
    category: "Automation Tools", 
    seller: "MarketAI", 
    price: 199, 
    description: "An AI tool for automating marketing campaigns, featuring lead scoring, email scheduling, and performance tracking. Boosts ROI by targeting the right audience with personalized content.", 
    rating: 4.7,
    imageUrl: "https://via.placeholder.com/150?text=Marketing+Automation+Tool"
  },
  { 
    id: 46, 
    name: "ETF Trading AI", 
    category: "Forex Trading Software", 
    seller: "ETFTech", 
    price: 499, 
    description: "AI software for ETF market predictions, analyzing exchange-traded funds with real-time data and trend forecasting. Offers automated trading options and portfolio diversification insights.", 
    rating: 4.8,
    imageUrl: "https://via.placeholder.com/150?text=ETF+Trading+AI"
  },
  { 
    id: 47, 
    name: "Arbitrage Trading Bot", 
    category: "Trading Bots", 
    seller: "ArbitrageBot", 
    price: 999, 
    description: "An AI bot for exploiting arbitrage opportunities in crypto markets, executing trades across exchanges to profit from price differences. Features low-latency performance and risk management tools.", 
    rating: 4.9,
    imageUrl: "https://via.placeholder.com/150?text=Arbitrage+Trading+Bot"
  },
];

const pageSize = 4;

const SellAIProducts = () => {
  const [currentTab, setCurrentTab] = useState("AI Models");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);

  const handleTabChange = (key) => {
    setCurrentTab(key);
    setCurrentPage(1);
    setSearchQuery("");
    setSelectedPriceRange(null);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handlePriceRangeChange = (value) => {
    setSelectedPriceRange(value);
    setCurrentPage(1);
  };

  const filteredProducts = useMemo(() => {
    let filtered = products.filter((product) => product.category === currentTab);
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (product) =>
          product.name.toLowerCase().includes(query) ||
          product.description.toLowerCase().includes(query)
      );
    }
    if (selectedPriceRange) {
      const [min, max] = selectedPriceRange.split("-").map(Number);
      filtered = filtered.filter(
        (product) => product.price >= min && (max ? product.price <= max : true)
      );
    }
    return filtered;
  }, [currentTab, searchQuery, selectedPriceRange]);

  const paginatedProducts = useMemo(() => {
    return filteredProducts.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  }, [filteredProducts, currentPage]);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5 ? 1 : 0;
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} style={{ color: "#fa8c16", marginRight: "4px" }} />);
    }
    if (halfStar) {
      stars.push(<FaStar key="half" style={{ color: "#fa8c16", marginRight: "4px", opacity: 0.5 }} />);
    }
    return stars;
  };

  return (
    <Layout>
      <Content style={{ padding: "60px", background: "linear-gradient(135deg, #e6fffb, #fff7e6)", minHeight: "100vh" }}>
        <Title level={2} style={{ fontSize: "20px", color: "#13c2c2", textAlign: "center", fontWeight: "700", marginBottom: "28px" }}>
          <FaShoppingCart style={{ marginRight: "14px", fontSize: "20px", color: "#fa8c16" }} /> Sell AI Products
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#595959", textAlign: "center", marginBottom: "32px", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", lineHeight: "1.6" }}>
          Discover and trade cutting-edge AI models, APIs, datasets, automation tools, and trading bots on JectHub. Start exploring or list your own innovative product today!
        </Paragraph>

        <Row gutter={[24, 24]} style={{ marginBottom: "32px", alignItems: "center" }}>
          <Col xs={24} md={12}>
            <Tabs
              defaultActiveKey="AI Models"
              onChange={handleTabChange}
              tabBarStyle={{ fontWeight: "700", color: "#13c2c2", borderBottom: "3px solid #13c2c2" }}
            >
              <TabPane tab="AI Models" key="AI Models" />
              <TabPane tab="APIs" key="APIs" />
              <TabPane tab="Datasets" key="Datasets" />
              <TabPane tab="Automation Tools" key="Automation Tools" />
              <TabPane tab="AI Software" key="AI Software" />
              <TabPane tab="Forex Trading Software" key="Forex Trading Software" />
              <TabPane tab="Trading Bots" key="Trading Bots" />
            </Tabs>
          </Col>
          <Col xs={24} md={6}>
            <Input
              placeholder="Search products by name or description"
              prefix={<SearchOutlined />}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ borderRadius: "8px", height: "44px", boxShadow: "0 3px 6px rgba(0,0,0,0.1)", border: "none" }}
            />
          </Col>
          <Col xs={24} md={6}>
            <Select
              placeholder="Filter by Price Range"
              size="large"
              onChange={handlePriceRangeChange}
              style={{ width: "100%", borderRadius: "8px" }}
              allowClear
              dropdownStyle={{ borderRadius: "8px" }}
            >
              <Option value={null}>All Prices</Option>
              <Option value="0-50">$0 - $50</Option>
              <Option value="51-100">$51 - $100</Option>
              <Option value="101-200">$101 - $200</Option>
              <Option value="201-300">$201 - $300</Option>
              <Option value="301-">$301+</Option>
            </Select>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          {paginatedProducts.length > 0 ? (
            paginatedProducts.map((product) => (
              <Col xs={24} sm={12} md={8} lg={6} key={product.id}>
                <div className="flip-container" style={{ perspective: "1000px", height: "380px" }}>
                  <div className="flip-card">
                    {/* Front Side */}
                    <Card
                      className="flip-card-front"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                        background: "linear-gradient(135deg, #ffffff, #f0fafa)",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div>
                        <img
                          src={product.imageUrl}
                          alt={product.name}
                          style={{ width: "100%", height: "140px", objectFit: "cover", borderRadius: "8px", marginBottom: "12px" }}
                        />
                        <Title level={5} style={{ marginBottom: "8px", color: "#1a1a1a", textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                          {product.name}
                        </Title>
                        <div style={{ textAlign: "center", marginBottom: "8px" }}>
                          {renderStars(product.rating)}
                        </div>
                        <Paragraph style={{ marginBottom: "8px", color: "#595959", textAlign: "center", fontSize: "14px" }}>
                          <strong style={{ color: "#13c2c2" }}>Seller:</strong> {product.seller}
                        </Paragraph>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Paragraph style={{ marginBottom: "12px", color: "#1a1a1a", fontWeight: "bold", fontSize: "16px" }}>
                          <FaDollarSign style={{ marginRight: "4px", color: "#fa8c16" }} /> {product.price} USD
                        </Paragraph>
                        <Button
                          type="primary"
                          icon={<FaShoppingCart style={{ marginRight: "8px" }} />}
                          href="/signin"
                          style={{
                            background: "linear-gradient(45deg, #fa8c16, #d46b08)",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            height: "44px",
                            width: "100%",
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "linear-gradient(45deg, #d46b08, #ad4e00)";
                            e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.3)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "linear-gradient(45deg, #fa8c16, #d46b08)";
                            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                          }}
                        >
                          Buy Now
                        </Button>
                      </div>
                    </Card>
                    {/* Back Side */}
                    <Card
                      className="flip-card-back"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                        background: "linear-gradient(135deg, #f0fafa, #e6fffb)",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <Title level={5} style={{ marginBottom: "12px", color: "#1a1a1a", textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                          {product.name}
                        </Title>
                        <Paragraph style={{ color: "#595959", fontSize: "14px", height: "160px", overflow: "auto", lineHeight: "1.5", marginBottom: "12px" }}>
                          {product.description}
                        </Paragraph>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <div style={{ marginBottom: "8px" }}>
                          {renderStars(product.rating)}
                        </div>
                        <Paragraph style={{ marginBottom: "12px", color: "#1a1a1a", fontWeight: "bold", fontSize: "16px" }}>
                          <FaDollarSign style={{ marginRight: "4px", color: "#13c2c2" }} /> {product.price} USD
                        </Paragraph>
                        <Button
                          type="primary"
                          icon={<FaShoppingCart style={{ marginRight: "8px" }} />}
                          href="/signin"
                          style={{
                            background: "linear-gradient(45deg, #13c2c2, #08979c)",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            height: "44px",
                            width: "100%",
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "linear-gradient(45deg, #08979c, #006d75)";
                            e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.3)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "linear-gradient(45deg, #13c2c2, #08979c)";
                            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                          }}
                        >
                          Buy Now
                        </Button>
                      </div>
                    </Card>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col span={24} style={{ textAlign: "center", marginTop: "24px" }}>
              <Paragraph style={{ color: "#999", fontSize: "16px" }}>
                No products match your filters. Try adjusting your search or price range!
              </Paragraph>
            </Col>
          )}
        </Row>

        <Pagination
          current={currentPage}
          total={filteredProducts.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          style={{ marginTop: "32px", textAlign: "center", fontSize: "16px" }}
          showSizeChanger={false}
        />

        <Button
          type="primary"
          style={{
            marginTop: "32px",
            background: "linear-gradient(45deg, #52c41a, #389e0d)",
            border: "none",
            borderRadius: "8px",
            fontWeight: "bold",
            height: "48px",
            padding: "0 24px",
            fontSize: "16px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "linear-gradient(45deg, #389e0d, #237804)";
            e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "linear-gradient(45deg, #52c41a, #389e0d)";
            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
          }}
          onClick={() => alert("Redirect to sell form (to be implemented)")}
        >
          Sell Your AI Product
        </Button>

        {/* Custom CSS */}
        <style jsx global>{`
          .flip-container {
            perspective: 1000px;
          }
          .flip-card {
            position: relative;
            width: 100%;
            height: 100%;
            transition: transform 0.6s;
            transform-style: preserve-3d;
          }
          .flip-container:hover .flip-card {
            transform: rotateY(180deg);
          }
          .flip-card-front,
          .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            animation: fadeIn 0.5s ease-in-out;
          }
          .flip-card-back {
            transform: rotateY(180deg);
          }
          .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #13c2c2 !important;
          }
          .ant-tabs-ink-bar {
            background: #13c2c2 !important;
          }
          .ant-pagination-item-active {
            border-color: #fa8c16 !important;
          }
          .ant-pagination-item-active a {
            color: #fa8c16 !important;
          }
          .ant-select-selector {
            border: none !important;
            box-shadow: 0 3px 6px rgba(0,0,0,0.1) !important;
            height: 44px !important;
            display: flex !important;
            align-items: center !important;
          }
          .ant-select-selection-placeholder {
            color: #888 !important;
          }
          @keyframes fadeIn {
            0% { opacity: 0; transform: translateY(10px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </Content>
    </Layout>
  );
};

export default SellAIProducts;